import { Injectable } from '@angular/core';
import { LocationsApiService } from './locations-api.service';
import { Subject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class GoogleRouteService {
  private mapLoaded = false;
  private directionService!: google.maps.DirectionsService;
  private distanceService!: google.maps.DistanceMatrixService;

  constructor(private locationsApiService: LocationsApiService) {}
  
  async loadGoogleMapsApi() {
    if (this.mapLoaded) return;
    await this.locationsApiService.loadGoogleMapsApi();
    if (google) {
      this.directionService = new google.maps.DirectionsService();
      this.distanceService = new google.maps.DistanceMatrixService();
      this.mapLoaded = true;
      return;
    }
    throw Error('maps not loaded');
  }
  drawRoute(points: google.maps.LatLngLiteral[]): Observable<{
    polylinePoints: google.maps.LatLng[];
    duration: number;
    distance: number;
    durationInTraffic: number;
  }> {
    const route$ = new Subject<{
      polylinePoints: google.maps.LatLng[];
      duration: number;
      distance: number;
      durationInTraffic: number;
    }>();
    this.loadGoogleMapsApi()
      .then(() => {
        const waypoints = points.slice(1, points.length - 1).map((point) => ({ location: point }));
        this.directionService.route(
          {
            origin: points[0],
            destination: points[points.length - 1],
            waypoints: waypoints,
            travelMode: google.maps.TravelMode.DRIVING,
            drivingOptions: {
              departureTime: new Date(),
              trafficModel: google.maps.TrafficModel.BEST_GUESS,
            },
          },
          (response: google.maps.DirectionsResult, status: google.maps.DirectionsStatus) => {
            if (status === google.maps.DirectionsStatus.OK) {
              const route = response.routes[0];
              route$.next({
                polylinePoints: route?.overview_path || [],
                duration: (route?.legs[0]?.duration?.value || 0) * 1000,
                distance: route?.legs[0]?.distance?.value || 0,
                durationInTraffic: (route?.legs[0]?.duration_in_traffic?.value || 0) * 1000,
              });
              route$.complete();
            } else {
              route$.error(new Error(`Directions request failed due to ${status}`));
            }
          }
        );
      })
      .catch((error) => route$.error(error));
    return route$.asObservable();
  }
}
